import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'

import { useMediaQuery } from 'src/lib/use-media-query'
import common from 'src/styles/common.module.scss'

export const TextHeaderDe = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    return (
        <HighlightedText
            text="DREHEN SIE DAS RAD UND ERHALTEN SIE FREISPIELE"
            highlights={[{ word: 'SIE' }, { word: 'FREISPIELE' }]}
            breakAfterWords={isDesktop ? ['ERHALTEN'] : ['RAD', 'ERHALTEN']}
            className={common.text_header}
        />
    )
}
